"use client";

import * as React from "react";
import {
	BookOpen,
	Bot,
	GalleryVerticalEnd,
	Settings2,
	SquareTerminal,
} from "lucide-react";

import {NavMain} from "@ozon-ai/components/sidebar/nav-main";
import {NavUser} from "@ozon-ai/components/sidebar/nav-user";
import {StoreSwitcher} from "@ozon-ai/components/sidebar/store-switcher";
import {useAuth} from "../../context/AuthContext";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
} from "@/components/ui/sidebar.tsx";

const data = {
	teams: [
		{
			name: "Altlabz",
			logo: GalleryVerticalEnd,
			plan: "Enterprise",
		},
	],
	navMain: [
		{
			title: "Дашборд",
			url: "/dashboard",
			icon: SquareTerminal,
			isActive: true,
		},
		{
			title: "Планы",
			url: "/plans",
			icon: SquareTerminal,
			isActive: true,
		},
		{
			title: "Действия",
			url: "/actions",
			icon: Bot,
		},
		{
			title: "Закупки",
			url: "/purchases",
			icon: BookOpen,
		},
		{
			title: "Ozon",
			url: "/ozon",
			icon: Settings2,
			items: [
				{
					title: "Товар",
					url: "/ozon/products",
				},
				{
					title: "Остатки",
					url: "/ozon/stocks",
				},
				{
					title: "Экономика магазина",
					url: "/ozon/store-economics",
				},
				{
					title: "Динамика продаж",
					url: "/ozon/dynamic",
				},
			],
		},
		{
			title: "Анализы",
			url: "/analyses",
			icon: Settings2,
			items: [
				{
					title: "Анализ SKU",
					url: "/analyses/sku",
				},
				{
					title: "Поставки",
					url: "/purchases",
				},
				{
					title: "Закупки",
					url: "#",
				},
				{
					title: "Дайджест",
					url: "/analyses/digest",
				},
				{
					title: "Продажи",
					url: "#",
				},
			],
		},
	],
};

export function AppSidebar({...props}: React.ComponentProps<typeof Sidebar>) {
	const {user, logout} = useAuth();

	return (
		<Sidebar collapsible="icon" {...props}>
			<SidebarHeader>
				<StoreSwitcher stores={data.teams}/>
			</SidebarHeader>
			<SidebarContent>
				<NavMain items={data.navMain}/>
			</SidebarContent>
			<SidebarFooter>
				<NavUser
					user={{
						name: user?.username ?? "Пользователь",
						email: user?.role ?? "",
					}}
					onLogout={() => void logout()}
				/>
			</SidebarFooter>
			<SidebarRail/>
		</Sidebar>
	);
}
